import {Component, Input, OnChanges, Output, EventEmitter,} from '@angular/core';
import { BolivarDigitalVm } from 'src/app/view-model/bolivar-digital/bolivar-digital.vm';
  
  @Component({
    selector: 'app-bolivar-digital-button',
    templateUrl: './bolivar-digital-button.component.html',
    styleUrls: ['./bolivar-digital-button.component.scss'],
  })
  export class BolivarDigitalButton implements OnChanges {
    @Input() product: any = null;
    @Input() billing: any = null;
    @Input() isCheckout: boolean = false;
    @Output() clicked = new EventEmitter();

    constructor(private vm: BolivarDigitalVm) {}
  
    openModal(event: Event, sw: boolean = true) {
      event.stopPropagation();
      event.preventDefault();
      this.vm.openModal.emit({ 
        product: this.product, 
        billing: this.billing, 
        isCheckout: this.isCheckout
      });
      return false;
    }
  
    ngOnChanges() {}
  }
  